const vClickOutsideDirective = {
  mounted (el, binding) {
    el._clickOutsideHandler = (event) => {
      const { parentId, handler } = binding.value;
      const parentEl = document.getElementById(parentId);

      if (parentEl && handler && !el.contains(event.target) && !parentEl.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener('click', el._clickOutsideHandler);
  },
  unmounted (el) {
    document.removeEventListener('click', el._clickOutsideHandler);
  },
};

export default vClickOutsideDirective;
